<template>
  <div
    @click="opened = !opened"
    :class="['sharing', {'sharing_opened': opened, 'sharing_alt-direction': altDirection}, {'sharing-rev': revButton }]"
    v-click-outside="close">
    <div class="sharing__button">
      поделиться
    </div>
    <svg class="sharing__arrow" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0H4H8L4 8L0 0Z" fill="#292929"/></svg>
    <transition name="slide-fade">
      <div class="sharing__list" v-if="opened">
        <yandex-share
          @ready="ready = true"
          @share="close"
          :services="enabled"
          bare
        />
        <div v-if="!ready" class="sharing__load">
          <img src="/frontend/assets/img/loader2.gif" alt="">
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import YandexShare from '@cookieseater/vue-yandex-share';

export default {
  name: 'Sharing',
  components: {
    YandexShare,
  },
  props: {
    altDirection: {
      type: Boolean,
      default: false,
    },
    revButton: { type: Boolean, default: false },
    enabled: {
      type: Array,
      default: () => ['twitter'],
    }
  },
  data() {
    return {
      opened: false,
      ready: false
    }
  },
  methods: {
    open() {
      this.opened = true;
    },
    close() {
      this.opened = false;
    }
  }
}
</script>
